import React, { Component } from 'react';
import actions from '../../redux/actions/index';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import HotelCard from './hotel-card';
import SearchFilter from './filter-container';
import SearchSort from './sort-resut';
import { TravcoHotelDetailsModal } from 'travco-modal';
import SearchPagination from './pagination';
import LoadingSpinner from 'travco-loading-spinner';
import _object from 'lodash/fp/object';
import _array from 'lodash/array';
import _sumBy from 'lodash/sumBy';
import _sortBy from 'lodash/sortBy';
import _orderBy from 'lodash/orderBy';
import placeholder from '../../images/PlaceholderRoss.png';

class SearchResultContainer extends Component {
    constructor(props) {
        super(props);
        this.hotelViewPopupHandler = this.hotelViewPopupHandler.bind(this);
        this.state = {
            hotel: null,
            showModal: false
        };
    }

    hotelViewPopupHandler(model) {
        if (model && model.id) this.setState({ hotel: model, showModal: true });
        else this.setState({ hotel: model, showModal: false });
    }

    render() {
        const { isLoading, filtersActive, noSearchPerformed, model,totalItemCount } = this.props;
        const { hotel, showModal} = this.state;
        
        let body;

        if (isLoading){
            body = <LoadingSpinner />;
        } else if (filtersActive){
            body = model.map((hotel, index) => (
                <HotelCard model={hotel} key={'searchResult-' + index} openHotelViewPopUp={this.hotelViewPopupHandler} />
            ));
        } else if (!filtersActive && !isLoading && !noSearchPerformed){
            body = <div>
                <h4 className="empty-state-title">No results found</h4>
                <p className="empty-state-body">
                    Try adjusting your search to find what you are looking for.
                </p>
            </div>;
        } else if (noSearchPerformed){
            body = <div>
                <h4 className="empty-state-title">Find your accommodation</h4>
                <p className="empty-state-body">
                    Try the search form above to see what is available.
                </p>
            </div>;
        }

        return (
            <div className="results-view">
                <div className="travco-body">
                    <div className="travco-grid-fluid gutter">
                        <div className="tg-cell">
                            <div className="content">
                                <SearchSort/>
                                <span className="travco-result-counter">{`Total Hotel Count: ${totalItemCount}`}</span>
                            </div>
                        </div>
                    </div>
                    <div className="travco-grid-fluid gutter">
                        <div className="tg-cell-2-8">
                            <div className="content">
                                <SearchFilter />
                            </div>
                        </div>
                        <div className="tg-cell">
                            <div className="content">
                                {body}
                            </div>
                        </div>
                    </div>
                    <div className="travco-grid-fluid gutter">
                        <div className="tg-cell">
                            <div className="content">
                                <SearchPagination />
                            </div>
                        </div>
                    </div>
                </div>
                {showModal && (
                    <TravcoHotelDetailsModal
                        isDialogActive={showModal}
                        model={appendRoomCategoriesToHotel(hotel,   this.props.model)}
                        images={
                            hotel.pictures.length < 1 || !hotel.pictures ? [ { link: placeholder } ] : hotel.pictures
                        }
                        onConfirm={this.hotelViewPopupHandler}
                    />
                )}
            </div>
        );
    }
}

function appendRoomCategoriesToHotel(hotel, model) {

    const rates = getRatesByHotelId(model, hotel.id);

    const allRoomCategories = rates.map(rate => rate.roomCategory);

   return {...hotel, roomCategories: allRoomCategories};

}

function getRatesByHotelId(hotelsAndRates, hotelId) {
    // Loop through each item in the array
    for (let item of hotelsAndRates) {
        // Find the hotel with the given id
        if (item.hotel.id === hotelId) {
            // Return the rates for that hotel
            return item.rates;
        }
    }

    // If no hotel with the given id is found, return null
    return null;
}

function mapStateToProps(state) {
    const model = state?.xml?.data || [];
    const isLoading = state.pendingTasks > 0;
    const filtersActive = model.length > 0;
    const noSearchPerformed = state.xml === null && !isLoading;
    const totalItemCount = state?.xml?.totalItemCount || 0;
    return {
        model,
        settings: state.settings,
        token: state?.oidc?.user?.id_token || '',
        isLoading,
        filtersActive,
        noSearchPerformed,
        totalItemCount
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchResultContainer);
